/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S4_Li1Inputs */

const tr_onbilgi_s4_li1 = /** @type {(inputs: Onbilgi_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipay Sanal POS altyapısı üzerinden kredi kartı veya banka kartı ile ödeme ya da Sağlayıcı'nın ödeme adımında bildirdiği banka hesabına havale/EFT. Havale/EFT'de açıklama alanına verilen şirket kodu yazılır; abonelik, bedelin hesaba ulaşmasının ardından aktif edilir ve ödenmeyen havale siparişi 7 (yedi) gün sonra kendiliğinden düşer.`)
};

const en_onbilgi_s4_li1 = /** @type {(inputs: Onbilgi_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment by credit or debit card via the Sipay Sanal POS infrastructure, or by bank transfer/EFT to the bank account the Provider states in the payment step. For bank transfer/EFT the given company code is entered in the payment description; the subscription is activated once the amount has been received, and an unpaid transfer order lapses automatically after 7 (seven) days.`)
};

const de_onbilgi_s4_li1 = /** @type {(inputs: Onbilgi_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung per Kredit- oder Bankkarte über die Sanal-POS-Infrastruktur von Sipay oder per Überweisung/EFT auf das Bankkonto, das der Anbieter im Zahlungsschritt nennt. Bei Überweisung/EFT wird der mitgeteilte Firmenkode in den Verwendungszweck eingetragen; das Abonnement wird nach Eingang des Betrags aktiviert, und eine nicht bezahlte Überweisungsbestellung verfällt nach 7 (sieben) Tagen von selbst.`)
};

const ru_onbilgi_s4_li1 = /** @type {(inputs: Onbilgi_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплата кредитной или дебетовой картой через инфраструктуру Sipay Sanal POS либо банковским переводом/EFT на банковский счёт, который Поставщик указывает на шаге оплаты. При переводе/EFT в назначении платежа указывается выданный код компании; подписка активируется после поступления суммы, а неоплаченный заказ с переводом автоматически аннулируется через 7 (семь) дней.`)
};

/**
* | output |
* | --- |
* | "Payment by credit or debit card via the Sipay Sanal POS infrastructure, or by bank transfer/EFT to the bank account the Provider states in the payment step. ..." |
*
* @param {Onbilgi_S4_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s4_li1 = /** @type {((inputs?: Onbilgi_S4_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S4_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s4_li1(inputs)
	if (locale === "de") return de_onbilgi_s4_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s4_li1(inputs)
	return tr_onbilgi_s4_li1(inputs)
});